module.exports = __webpack_public_path__ + "img/stateblue_bg.2bffe51d.png";